import GLightbox from "glightbox";
import React, {useEffect} from "react";
import {FiPlay} from "react-icons/fi";
import data from "../data/cta.json";

const Ctav4 = ({isBg}) => {
  const {ctav4} = data;
  useEffect(() => {
    GLightbox({
      selector: ".glightbox3",
    });
  }, []);

  return (
    // <!-- ========== CTA v4 section start ========== -->
    <section
      id="characters"
      className={`section-padding ctav4 ${isBg === "yes" ? "bg-one" : ""}`}
      style={{backgroundImage: `url(${ctav4.backgroundImage})`}}
    >
      <div className="container">
        <div className="row">
          <div className=" mb-4 mb-lg-0 ctav4__content text-center d-flex flex-column align-items-center">
            <h3
              className="display-3"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="150"
            >
              {ctav4.title}
            </h3>
            <h3
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              {ctav4.subtitle}
            </h3>
            <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="250">
              {ctav4.text}
            </p>

            <a
              href="/characters"
              className="smooth button button__primary"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="300"
            >
              <span>{ctav4.btnText}</span>
            </a>
          </div>
          <div
            className="col-md-6"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="250"
          >
            <div className="ctav4__video-btn">
              {ctav4.videoURL === "" ? "" : <></>}
            </div>
          </div>
        </div>
      </div>
    </section>
    // <!-- ========== CTA v4 section end ========== -->
  );
};

export default Ctav4;
